import React from 'react';
import { IoAdd, IoInformationCircleOutline } from 'react-icons/io5';
import './MissingDataIndicator.css';

interface Props {
  missingCount: number;
  onClick?: () => void;
  className?: string;
}

const MissingDataIndicator: React.FC<Props> = ({ missingCount, onClick, className }) => {
  if (!missingCount || missingCount <= 0) return null;

  return (
    <button
      onClick={onClick}
      className={['missing-data-indicator', className || ''].join(' ').trim()}
      type="button"
    >
      <IoInformationCircleOutline className="missing-data-indicator-icon" />
      <span className="missing-data-indicator-text">
        ({missingCount}) detail{missingCount !== 1 ? 's' : ''} missing. Click to add.
      </span>
      <IoAdd className="missing-data-indicator-add-icon" />
    </button>
  );
};

export default MissingDataIndicator;
